import { render } from "./FuelupLogo.vue?vue&type=template&id=8062638a&ts=true"
import script from "./FuelupLogo.vue?vue&type=script&lang=ts"
export * from "./FuelupLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__